import { useSelector } from 'react-redux';
import { selectSiteTextColor } from '../redux/selectors';
import { SiteColor } from '../types/SiteColor';
import { wixSdkAdapter } from '../utils/wixSdkAdapter';

export const useSiteStyles = (): {
  textColor: string;
} => {
  let textColor: string = useSelector(selectSiteTextColor);

  if (!textColor && wixSdkAdapter.isConnected()) {
    const siteColors = wixSdkAdapter.Wix.Styles?.getSiteColors() || [];

    textColor = siteColors.find(
      ({ reference }) => reference === SiteColor.Text
    )?.value;
  }

  return {
    textColor,
  };
};
